import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@mui/material';

const UploadDropdown = props => {
  const { options, disabled } = props;
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleMenuItemClick = (event, option) => {
    setOpen(false);
    if (option.action) {
      option.action();
    }
  };

  const handleMainButtonClick = () => {
    if (options.length > 0 && options[0].action) {
      options[0].action();
    }
  };

  return (
    <>
      <ButtonGroup ref={anchorRef} aria-label="Upload button group">
        <Button
          variant={'contained'}
          sx={{
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          }}
          onClick={handleMainButtonClick}
          disabled={disabled || (options.length > 0 && options[0].disabled)}
        >
          {options.length > 0 && options[0].title}
        </Button>
        <Button
          variant={'outlined'}
          sx={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            minWidth: '32px',
            padding: '4px 8px',
          }}
          size="small"
          aria-owns={open ? 'upload-menu-list' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          disabled={disabled}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper sx={{ zIndex: 1 }} open={open} anchorEl={anchorRef.current} transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper elevation={1} id="upload-menu-list">
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList>
                  {options.slice(1).map(option => (
                    <MenuItem
                      key={option.key || option.title}
                      disabled={option.disabled}
                      onClick={event => handleMenuItemClick(event, option)}
                    >
                      {option.title}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

UploadDropdown.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      title: PropTypes.node.isRequired,
      action: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
};

export default UploadDropdown;
